export default "__VITE_ASSET__sy_Za42K__"